/**
 * Calculates age in years from a date string
 * @param {string} dateString - Date string (default format: dd/mm/YYYY)
 * @returns {number} Age in years
 */
export const calculateAge = (dateString) => {
  try {
    // Handle different date formats
    let birthDate;

    if (dateString.includes('/')) {
      // Handle dd/mm/YYYY format
      const [day, month, year] = dateString.split('/');
      birthDate = new Date(year, month - 1, day);
    } else if (dateString.includes('-')) {
      // Handle YYYY-mm-dd format
      birthDate = new Date(dateString);
    } else {
      // Try to parse the date directly
      birthDate = new Date(dateString);
    }

    // Check if date is valid
    if (isNaN(birthDate.getTime())) {
      throw new Error('Invalid date format');
    }

    const today = new Date();
    let age = today.getFullYear() - birthDate.getFullYear();
    const monthDiff = today.getMonth() - birthDate.getMonth();

    // Adjust age if birthday hasn't occurred this year
    if (
      monthDiff < 0 ||
      (monthDiff === 0 && today.getDate() < birthDate.getDate())
    ) {
      age--;
    }

    return age;
  } catch (error) {
    console.error('Error calculating age:', error);
    return null;
  }
};
